/** The "doing X" progress screen shown while the effect runs, before handoff. For a Product Campaign the
 *  target product's cover is shown (dimmed) behind a teal spinner so the transient screen feels continuous
 *  with the interstitial. Tokenized to the shared design system (warm paper, accent spinner). */
export function WorkingScreen({ label, coverUrl }: { label: string; coverUrl?: string }) {
  return (
    <div
      className="flex min-h-0 flex-1 flex-col items-center justify-center gap-6 px-6 text-center"
      style={{ background: 'var(--scr)' }}>
      {coverUrl ? (
        <div className="relative h-28 w-28 overflow-hidden rounded-[18px]" style={{ boxShadow: '0 10px 30px rgba(40,25,10,.18)' }}>
          <img src={coverUrl} alt="" className="h-full w-full object-cover opacity-40" />
          <div className="absolute inset-0 grid place-items-center">
            <Spinner />
          </div>
        </div>
      ) : (
        <Spinner />
      )}
      <p className="t-body-strong" style={{ color: 'var(--txt2)' }}>{label}</p>
    </div>
  )
}

function Spinner() {
  return (
    <div
      className="h-10 w-10 animate-spin rounded-full border-[3px]"
      style={{ borderColor: 'var(--color-line)', borderTopColor: 'var(--acc)' }}
    />
  )
}
